import { PulseTriggerType } from '../../clients/PulseIdentityServiceClient/generated/PulseIdentityClient/types';
import { isValidBase } from '../BaseEntity';
export { PulseTriggerType };
export const isValidPulseIdentity = properties => {
  return isValidBase(properties);
};
//# sourceMappingURL=PulseIdentity.js.map